var _defs, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsEtudes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    "data-name": "Calque 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #bf764d;\n      }\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 50.05,
    cy: 13.95,
    r: 13.95
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.86,8.16h-13.96c-3.21,0-5.82,2.61-5.82,5.82v19.78h25.59V13.97c0-3.21-2.61-5.82-5.82-5.82ZM27.35,31.42H6.41V13.97c0-1.93,1.56-3.49,3.49-3.49h13.96c1.93,0,3.49,1.56,3.49,3.49v17.45ZM54.1,38.41h-13.96c-3.21,0-5.82,2.61-5.82,5.82v19.78h25.59v-19.78c0-3.21-2.61-5.82-5.82-5.82ZM57.59,61.67h-20.94v-17.45c0-1.93,1.56-3.49,3.49-3.49h13.96c1.93,0,3.49,1.56,3.49,3.49v17.45ZM35.35,21.09c-1.35-1.35-1.35-3.58,0-4.93l7.66-7.66,1.65,1.65-7.33,7.33h9.8c4.49,0,8.14,3.65,8.14,8.14v8.14h-2.33v-8.14c0-3.21-2.61-5.82-5.82-5.82h-9.8l7.33,7.33-1.65,1.65-7.66-7.66v-.05ZM28.65,51.06c1.35,1.35,1.35,3.58,0,4.93l-7.66,7.66-1.65-1.65,7.33-7.33h-9.8c-4.49,0-8.14-3.65-8.14-8.14v-8.14h2.33v8.14c0,3.21,2.61,5.82,5.82,5.82h9.8l-7.33-7.33,1.65-1.65,7.66,7.66v.05Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsEtudes);
export default __webpack_public_path__ + "static/media/ICONS_Etudes.ae80de8366495786d67ca1332b838360.svg";
export { ForwardRef as ReactComponent };